import React, { Component } from 'react';
import cx from 'classnames';
import { compileQuery, parseQuery } from 'utils';

import s from './style';

import iconNedvex from 'assets/images/icons/type-filters/icon-nedvex.svg';
import iconNew from 'assets/images/icons/type-filters/icon-new.svg';
import iconAction from 'assets/images/icons/type-filters/icon-action.svg';
import iconPopular from 'assets/images/icons/type-filters/icon-popular.svg';
import iconBlacklist from 'assets/images/icons/type-filters/icon-blacklist.svg';
import tracker from '../../services/tracker';
import { withTranslation } from 'react-i18next';

const newOrderFields = ['visit_day', 'visit_week', 'visit_month'];

export const getRequest = (search) => {
  const request = {
    nedvex: search.nedvex,
    new: search.new,
    viewAction: search.viewAction,
    orderField: search.orderField,
    blackList: search.blackList
  };
  return request;
};

class TypeFilters extends Component {
  getFilters = (filters, request) => {
    const { location, history, changeFilters } = this.props;
    const { pathname, search } = location;
    const query = compileQuery(filters, search);
    const newSearch = query ? `?${query}` : '';
    const path = `${pathname}${newSearch}`;

    this.registerFilterClick(filters);

    history.push(path);
    changeFilters(request, { reset: true });
  }

  registerFilterClick = (filters) => {
    const { nedvex, new: newBuildings, viewAction, orderField, blackList } = filters;

    if (nedvex) {
      tracker.sendEvent('Web_ZHK_Nedvex');
    }

    if (newBuildings) {
      tracker.sendEvent('Web_New');
    }

    if (viewAction) {
      tracker.sendEvent('Web_Stock');
    }

    if (orderField) {
      tracker.sendEvent('Web_Popular');
    }

    if (blackList) {
      tracker.sendEvent('Web_Illegal');
    }
  }

  formFilters = (filters, options) => {
    const { location } = this.props;
    const search = parseQuery(location.search);
    const request = {
      nedvex: (search.nedvex && filters.nedvex) ? undefined : filters.nedvex,
      new: (search.new && filters.new) ? undefined : filters.new,
      viewAction: (search.viewAction && filters.viewAction) ? undefined : filters.viewAction,
      orderField: (newOrderFields.includes(search.orderField) && filters.orderField) ? undefined : filters.orderField,
      blackList: (search.blackList && filters.blackList) ? undefined : filters.blackList
    };
    const query = request;
    this.getFilters(request, query);
  }

  isActive = (filter) => {
    const { location } = this.props;
    const search = parseQuery(location.search);

    if (filter === 'orderField') {
      return newOrderFields.includes(search[filter]);
    }
    if (search[filter]) return true;
  };

  render() {
    const { t, isCottegesPage } = this.props;

    let wrapClass = (this.isActive('nedvex') || this.isActive('new') || this.isActive('viewAction') || this.isActive('orderField') || this.isActive('blackList')) ? 'Active' : null;
    return (
      <div className={cx(s.TypeFiltersWrap, s[wrapClass])}>
        {isCottegesPage === false && (
        <button className={cx(s.TypeFiltersBtn, s.Nedvex, this.isActive('nedvex') && s.Active)} onClick={() => this.formFilters({ nedvex: 'true' })}>
          <span className={s.TypeFiltersBtnLeft}>
            <img src={iconNedvex} alt="" />
          </span>
          <span className={s.TypeFiltersBtnRight}>NEDVEX</span>
        </button>
          )}
        <button className={cx(s.TypeFiltersBtn, s.New, this.isActive('new') && s.Active)} onClick={() => this.formFilters({ new: 'true' })}>
          <span className={s.TypeFiltersBtnLeft}>
            <img src={iconNew} alt="" />
          </span>
          <span className={s.TypeFiltersBtnRight}>
            {t('components.typeFilters.new')}
          </span>
        </button>
        <button className={cx(s.TypeFiltersBtn, s.Action, this.isActive('viewAction') && s.Active)} onClick={() => this.formFilters({ viewAction: 'true' })}>
          <span className={s.TypeFiltersBtnLeft}>
            <img src={iconAction} alt="" />
          </span>
          <span className={s.TypeFiltersBtnRight}>
            {t('components.typeFilters.promo')}
          </span>
        </button>
        <button className={cx(s.TypeFiltersBtn, s.Popular, this.isActive('orderField') && s.Active)} onClick={() => this.formFilters({ orderField: 'visit_day' })}>
          <span className={s.TypeFiltersBtnLeft}>
            <img src={iconPopular} alt="" />
          </span>
          <span className={s.TypeFiltersBtnRight}>
            {t('components.typeFilters.popular')}
          </span>
        </button>
      </div>
    );
  }
}

export default withTranslation()(TypeFilters);



// WEBPACK FOOTER //
// ./src/components/TypeFilters/TypeFilters.js